export function getOccupancyData(_plan) {
  // ⚠️ VALIDAÇÃO DEFENSIVA: Proteger contra dados malformados do backend
  if (!_plan) {
    console.error('[ERROR] getOccupancyData: _plan é null/undefined');
    return { ready: true };
  }
  
  if (!_plan.solution || !Array.isArray(_plan.solution)) {
    console.error('[ERROR] getOccupancyData: solution não é um array válido:', _plan.solution);
    return { ready: true };
  }

  try {
    let labels = getLabes();
    let matrix = getMatrixOccupancy(_plan, labels.cols, labels.rows);
    let charts = getCharts(
      matrix.matrix_ocuppancy_rate,
      labels.cols,
      labels.rows
    );

    return {
      ...matrix,
      ...labels,
      ...charts
    };
  } catch (error) {
    console.error('[ERROR] getOccupancyData falhou:', error);
    console.error('[ERROR] _plan.solution:', _plan.solution);
    return { ready: true };
  }
}

function normalizeRoomValue(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

export function isRealAllocatedRoom(room) {
  if (!room) return false;

  const bloco = normalizeRoomValue(room.bloco);
  const nome = normalizeRoomValue(room.nome || room.sala);
  const tipo = normalizeRoomValue(room.tipo);
  const id = normalizeRoomValue(room.id);

  return (
    `${bloco} ${nome}` !== "nao alocado" &&
    tipo !== "indefinido" &&
    id !== "nenhuma"
  );
}

export function getMatrixOccupancy(_plan, _cols, _rows) {

  let type_rooms = [];
  let rooms = _plan.solution
    // ⚠️ FILTRAR apenas salas reais válidas com classes
    .map((room, originalIdx) => ({ room, originalIdx }))
    .filter(({ room }) => {
      if (!room || !room.classes || !Array.isArray(room.classes)) {
        console.warn('[WARN] Room sem classes válidas:', room);
        return false;
      }
      return isRealAllocatedRoom(room);
    })
    .map(({ room: e, originalIdx }) => {
      if (!type_rooms.includes(e.tipo)) type_rooms.push(e.tipo);
      return {
        id: e.id,
        bloco: e.bloco,
        sala: e.nome,
        tipo: e.tipo,
        capacidade: e.capacidade,
        idx: originalIdx
      };
    });

  let time, _time;
  let matrix = [];
  let matrix_empty = [];

  for (let i = 0; i < 18; i++) {
    time = [];
    _time = [];
    for (let j = 0; j < 6; j++) {
      time.push([]);
      _time.push([...rooms]);
    }
    matrix.push(time);
    matrix_empty.push(_time);
  }

  let matrix_ocp = JSON.parse(JSON.stringify(matrix));

  _plan.solution
    // ⚠️ FILTRAR apenas salas reais com classes válidas
    .filter(
      room =>
        room &&
        room.classes &&
        Array.isArray(room.classes) &&
        isRealAllocatedRoom(room)
    )
    .forEach((room, i) => {
      // ⚠️ FILTRAR apenas disciplines válidas
      room.classes
        .filter(discipline => discipline && discipline.horario && typeof discipline.horario === 'string')
        .forEach((discipline, j) => {
          discipline.horario.split(" ").forEach(horario => {
            if (!horario) return; // Ignorar horários vazios
            
            let timeMatrix = convertUFPBTimeFormatToIdx(horario);
            
            // ⚠️ VALIDAR timeMatrix
            if (!timeMatrix || !Array.isArray(timeMatrix[0]) || !Array.isArray(timeMatrix[1])) {
              console.warn('[WARN] timeMatrix inválida:', timeMatrix);
              return;
            }
            
            let idx = rooms.findIndex(_ => _ && _.id == room.id);

            //now add classes to main matrix
            timeMatrix[0].forEach(week_day => {
              timeMatrix[1].forEach(time => {
                // ⚠️ VERIFICAR bounds antes de acessar matrix
                if (time < 0 || time >= 18 || week_day < 0 || week_day >= 6) {
                  console.warn('[WARN] Índices fora dos limites - time:', time, 'week_day:', week_day);
                  return;
                }
                
                // ⚠️ VERIFICAR se matrix_empty[time][week_day] existe
                if (!matrix_empty[time] || !matrix_empty[time][week_day]) {
                  console.warn('[WARN] matrix_empty[' + time + '][' + week_day + '] é undefined');
                  return;
                }
                
                let idx2 = matrix_empty[time][week_day].findIndex(
                  _ => _ && _.id == room.id
                );
                if (idx >= 0 && idx2 >= 0)
                  matrix_empty[time][week_day].splice(idx2, 1);

                matrix[time][week_day].push({
                  codigo: discipline.codigo,
                  nome: discipline.nome,
                  docente: discipline.docente,
                  sala: room.bloco + " " + room.nome,
                  id: discipline.codigo + "-" + discipline.turma,
                  j_idx: j,
                  i_idx: i
                });
              });
            });
          });
        });
    });

  let biggest = 0;

  let qtd_rooms = rooms.length;

  matrix.forEach(day => {
    day.forEach(h => {
      biggest = Math.max(biggest, h.length);
    });
  });

  let times_max = [];

  matrix_empty.forEach((time, i) => {
    time.forEach((day, j) => {
      let rate = qtd_rooms > 0 ? (qtd_rooms - day.length) / qtd_rooms : 0;
      matrix_ocp[i][j] = rate;
    });
  });

  matrix.forEach((time, i) => {
    time.forEach((day, j) => {
      let rate = biggest > 0 ? day.length / biggest : 0;
      if (biggest > 0 && rate == 1)
        times_max.push(`${_cols[j]}, ${_rows[i]}`);
    });
  });

  return {
    matrix_search_occupancy: matrix,
    matrix_ocuppancy_rate: matrix_ocp,
    max_value: biggest,
    times_with_max_value: times_max.sort(),
    matrix_search_empty: matrix_empty,
    qtd_rooms,
    type_rooms
  };
}

export function convertUFPBTimeFormatToIdx(_horario) {
  //converts UFPB time format to array
  //example '24T23' -> [[0, 2], [7,8]]

  let timeMatrix = [[], []];
  let changeCol = 0;
  let decrement = 2;
  let turno = 0;

  for (let i = 0; i < _horario.length; i++) {
    if (isNaN(Number(_horario.charAt(i)))) {
      changeCol = 1;
      decrement = 1;
      switch (_horario.charAt(i).toUpperCase()) {
        case "M":
          turno = 0;
          break;
        case "T":
          turno = 6;
          break;
        case "N":
          turno = 12;
          break;
      }
    } else
      timeMatrix[changeCol].push(
        turno + Number(_horario.charAt(i)) - decrement
      );
  }
  return timeMatrix;
}

export function getLabes() {
  return {
    cols: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    rows: [
      "07:00",
      "08:00",
      "09:00",
      "10:00",
      "11:00",
      "12:00",
      "13:00",
      "14:00",
      "15:00",
      "16:00",
      "17:00",
      "18:00",
      "19:00",
      "19:50",
      "20:40",
      "21:30"
    ]
  };
}

export function getCharts(_rate, _cols, _rows) {
  let values = [];
  let values2 = [];
  let value2_temp = [
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0]
  ];

  _rate.forEach((line, i) => {
    if (i >= 16) return;

    let count = 0;
    let sum = 0;

    line.forEach((e, j) => {
      if (e != 0) {
        count++;
        sum += e;

        value2_temp[j][0] += e;
        value2_temp[j][1] += 1;
      }
    });

    if (sum == 0) values.push(0);
    else values.push(Math.ceil((sum / count) * 100));
  });

  value2_temp.forEach(e => {
    if (e[1] == 0) values2.push(0);
    else values2.push(Math.ceil((e[0] / e[1]) * 100));
  });

  return {
    chart1: {
      labels: _rows,
      datasets: values
    },
    chart2: {
      labels: _cols,
      datasets: values2
    }
  };
}
